import { AuthorizationJsonSerialization } from '#authorization/jsonserializer'
import { AvlDeclaration, AvlDeclarations } from '#avl/model'
import { targetSpeciesCategory } from '#details/constants'
import { DetailsJsonSerialization } from '#details/jsonserializer'
import { utils } from 'apprise-core/utils'
import { useTenantStore } from 'apprise-frontend-iam/tenant/store'
import { useParseUtils } from 'apprise-frontend-parse/utils'



export type AvlPair = {

    uvi: string,
    patch: AvlDeclarations
}


export type MigrationItem = DetailsJsonSerialization & AuthorizationJsonSerialization & {

    date: string
    year: string
    species: string,
    charterer: string,
    charterer_address: string

}

export const useAvlRowParser = () => {


    const tenants = useTenantStore()
    const tenantmap = utils().index(tenants.all()).by(t => t.code)
    const parse = useParseUtils()
    
    return (row: MigrationItem): AvlDeclaration => {
        const species = parse.code2id(row.species).of(targetSpeciesCategory)

        const tenant = row.flagstate ? tenantmap[row.flagstate]?.id : undefined!
        
        return {

            tenant,
            year: row.year,
            species,
            charterer: {
                name: row.charterer,
                address: row.charterer_address
            }

        }

    }

}